import React, { useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { StoragePicker } from 'ui/atoms'
import { updateProperty } from 'providers/redux/actions'
import ProductService from 'services/ProductService'

export default function ProductStoragePicker({ className, productId, label }) {
  const { storage: productStorage } = useSelector(state => state.properties[productId]) || {}
  const { orderable } = ProductService.findProductById(productId) || {}
  const productStorages = ProductService.getProductProperty(productId, 'storages') || []
  const dispatch = useDispatch()

  const updateStorage = useCallback(
    newStorage => {
      if (!productStorages.findIndex(productStorage => productStorage === newStorage) < 0) return
      dispatch(updateProperty(productId, { storage: newStorage }))
    },
    [dispatch, productId, productStorages]
  )

  useEffect(() => {
    if (!productStorage && productStorages[0]) {
      updateStorage(productStorages[0])
    }
  })

  return (
    <StoragePicker
      className={className}
      disabled={!orderable}
      label={label}
      storage={productStorage}
      storages={productStorages.map(storage => ({ value: storage, label: `${storage} GB` }))}
      onChange={updateStorage}
    />
  )
}

ProductStoragePicker.propTypes = {
  className: PropTypes.string,
  productId: PropTypes.string.isRequired,
  label: PropTypes.string
}
